import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subject } from 'rxjs';
import { setInitialStoreState } from '../../../../../../../common/utils';
import { UliItemOverviewFacade } from './uli-item-overview.facade';
import { UliBriefFacade } from '../../uli-brief';
import { filter, take, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UliItemOverviewGuard {
  private unsubscribe$: Subject<boolean> = new Subject();
  constructor(private uliItemOverviewFacade: UliItemOverviewFacade, private uliBriefFacade: UliBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const {
      params: { id },
      queryParams: { compartmentId, type },
    } = route.parent;

    this.uliBriefFacade.getUliBrief(compartmentId, type, id);

    // 9614
    this.uliBriefFacade.uli$
      .pipe(filter(Boolean), takeUntil(this.unsubscribe$), take(1))
      .subscribe(() => this.uliItemOverviewFacade.loadAll());

    return true;
  }

  canDeactivate(): boolean {
    this.unsubscribe$.next(true);
    return setInitialStoreState(this.uliItemOverviewFacade);
  }
}
